import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';

import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import Radio from '@material-ui/core/Radio';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import moment from 'moment-timezone';
import {
    renderSingleDatePicker,
    renderControledTextField,
    renderSelect,
    renderSwitchWithLabel,
} from '../../utils/engageComponents'

const validate = (values) => {
    const errors = {};
    if (values.EndSelection && values.EndSelection.name === 'After') {
        if (!values.OccurrencesField) {
            errors.OccurrencesField = 'field required';
        }
    } else if (values.EndSelection && values.EndSelection.name === 'On this date') {

        if (!values.EndDate) {
            errors.EndDate = 'field required';
        }
    }

    if (!values.RepeatInterval) {
        errors.RepeatInterval = 'field required';
    }

    if (!values.Start) {
        errors.Start = 'field required';
    }

    if (!values.RepeatValue || (values.RepeatValue && values.RepeatValue.name && values.RepeatValue.name.length === 0)) {
        errors.RepeatValue = 'field required';
    }

    if (!values.EndSelection || values.EndSelection.name === '') {
        errors.EndSelection = 'field required';
    }



    if (!values.OccurrencesField) {
        errors.OccurrencesField = 'field required';
    }

    return errors;
};


//{inputObj = undefined, onSetDateHandler= undefined, openModal= false, onCloseModalHandler = undefined}
export class RecurrenceModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            //input props
            inputObj: props.inputObj ? props.inputObj : undefined,
            openModal: props.openModal ? props.openModal : false,
            onSetDateHandler: props.onSetDateHandler ? props.onSetDateHandler : undefined,
            onCloseModalHandler: props.onCloseModalHandler ? props.onCloseModalHandler : undefined,
            onSaveFormHandler: props.onSaveFormHandler ? props.onSaveFormHandler : undefined,

            //selected values
            StartDate: undefined,
            endDateForRecurrency: undefined,
            RepeatValue: { name: 'Daily' },// {name:'Weekly'}
            RepeatInterval: 2,
            RepeatValueOptions: [{ name: 'Daily' }, { name: 'Weekly' }, { name: 'Monthly' }, { name: 'Yearly' }],
            openRepeatValueCombo: false,
            openMonthsValueCombo: false,
            endDateEnabled: false,
            weekDays: [{ name: 'Sunday', short: 'S', value: 0 }, { name: 'Monday', short: 'M', value: 1 }, { name: 'Tuesday', short: 'T', value: 2 }, { name: 'Wednesday', short: 'W', value: 3 }, { name: 'Thursday', short: 'R', value: 4 }, { name: 'Friday', short: 'F', value: 5 }, { name: 'Saturday', short: 'S', value: 6 }],
            MonthValueOptions: [{ name: 'January', value: 0 }, { name: 'February', value: 1 }, { name: 'March', value: 2 }, { name: 'April', value: 3 }, { name: 'May', value: 4 }, { name: 'June', value: 5 }, { name: 'July', value: 6 }, { name: 'August', value: 7 }, { name: 'September', value: 8 }, { name: 'October', value: 9 }, { name: 'November', value: 10 }, { name: 'December', value: 11 }],
            selectedWeekDays: [{ name: 'Monday', short: 'M', value: 1 }, { name: 'Wednesday', short: 'W', value: 3 }, { name: 'Friday', short: 'F', value: 5 }],
            MonthValue: { name: 'January', value: 0 },

            EndSelection: { name: 'After' },
            endValuesOptions: [{ name: 'After' }, { name: 'On this date' }],
            OccurrencesField: 1,

            customMonthlyOptionSelected: 1,
            customMonthlyDayNumber: 1,
            monthlyOrdinalPosition: [{ name: 'First', order: 1 }, { name: 'Second', order: 2 }, { name: 'Third', order: 3 }, { name: 'Fourth', order: 4 }, { name: 'Last', order: 5 }],
            customSelectedMonthlyOrdinalPosition: { name: 'Last', order: 5 },
            customSelectedMonthlyRepetitionDay: { name: 'Monday', short: 'M', value: 1 },
            openMonthlyOrdinalPositionSelect: false,
            openMonthlyWeekDaySelect: false
        };
    };

    componentDidMount = () => {


        const tz = (this.props.communityFound && this.props.communityFound.timeZoneName) ? this.props.communityFound.timeZoneName : 'America/New_York';

        let startDate = this.props.inputObj.StartDate ? new moment(this.props.inputObj.StartDate).tz(tz) : new moment().tz(tz);
        let endrecurrencyDate = this.state.inputObj.endDateForRecurrency ? new moment(this.state.inputObj.endDateForRecurrency).tz(tz) : new moment(new Date()).tz(tz)

        const Syear = parseInt(startDate.format('YYYY'));
        const Smonth = parseInt(startDate.format('MM')) - 1;
        const Sday = parseInt(startDate.format('DD'));
        const newstartDate = new moment(new Date(Syear, Smonth, Sday))


        const Eyear = parseInt(endrecurrencyDate.format('YYYY'));
        const Emonth = parseInt(endrecurrencyDate.format('MM')) - 1;
        const Eday = parseInt(endrecurrencyDate.format('DD'));
        const newendDate = new moment(new Date(Eyear, Emonth, Eday))

        if (this.state.inputObj) {
            this.setState({
                tz: tz,
                StartDate: newstartDate,
                endDateForRecurrency: newendDate,
                RepeatValue: this.props.selectedRepeatValue ? this.props.selectedRepeatValue : { name: 'Daily' },
                RepeatInterval: this.state.inputObj.customRepeatInterval ? this.state.inputObj.customRepeatInterval : this.getDefaultRepeatValue(this.props.selectedRepeatValue ? this.props.selectedRepeatValue : { name: 'Daily' }),
                endDateEnabled: this.state.inputObj.endDateForRecurrency ? true : false,
                selectedWeekDays: (this.state.inputObj && this.state.inputObj.selectedWeekDays) ? this.state.inputObj.selectedWeekDays : [{ name: 'Monday', short: 'M', value: 1 }, { name: 'Wednesday', short: 'W', value: 3 }, { name: 'Friday', short: 'F', value: 5 }],

                MonthValue: (this.state.inputObj && this.state.inputObj.MonthValue) ? this.state.inputObj.MonthValue : { name: 'January', value: 0 },
                EndSelection: (this.state.inputObj && this.state.inputObj.EndSelection) ? this.state.inputObj.EndSelection : { name: 'After' },
                OccurrencesField: (this.state.inputObj && this.state.inputObj.customEndOcurrences) ? this.state.inputObj.customEndOcurrences : this.GetDefaultOcurrences(this.props.selectedRepeatValue ? this.props.selectedRepeatValue : { name: 'Daily' }),
                customMonthlyDayNumber: this.state.inputObj.customMonthlyDayNumber ? this.state.inputObj.customMonthlyDayNumber : 1,
                customMonthlyOptionSelected: this.state.inputObj.customMonthlyOptionSelected ? this.state.inputObj.customMonthlyOptionSelected : undefined,
                customSelectedMonthlyOrdinalPosition: this.state.inputObj.customSelectedMonthlyOrdinalPosition ? this.state.inputObj.customSelectedMonthlyOrdinalPosition : { name: 'First', order: 1 },
                customSelectedMonthlyRepetitionDay: this.state.inputObj.customSelectedMonthlyRepetitionDay ? this.state.inputObj.customSelectedMonthlyRepetitionDay : { name: 'Monday', short: 'M', value: 1 },
            },
                () => {

                    this.props.dispatch(change('RecurrenceModalForm', 'RepeatInterval', this.state.RepeatInterval));
                    this.props.dispatch(change('RecurrenceModalForm', 'RepeatValue', this.state.RepeatValue));
                    this.props.dispatch(change('RecurrenceModalForm', 'MonthValue', this.state.MonthValue));
                    this.props.dispatch(change('RecurrenceModalForm', 'StartDate', this.state.StartDate));
                    this.props.dispatch(change('RecurrenceModalForm', 'EndDate', this.state.endDateForRecurrency));
                    this.props.dispatch(change('RecurrenceModalForm', 'EnableEndDate_Switch', this.state.endDateEnabled));

                    this.props.dispatch(change('RecurrenceModalForm', 'EndSelection', this.state.EndSelection));
                    this.props.dispatch(change('RecurrenceModalForm', 'OccurrencesField', this.state.OccurrencesField));

                    this.props.dispatch(change('RecurrenceModalForm', 'monthlyDayNumber', this.state.customMonthlyDayNumber));
                    this.props.dispatch(change('RecurrenceModalForm', 'OrdinalPositionSelect', this.state.customSelectedMonthlyOrdinalPosition));
                    this.props.dispatch(change('RecurrenceModalForm', 'MonthlyWeekDatSelect', this.state.customSelectedMonthlyRepetitionDay));
                }
            )
        } else {
            this.props.dispatch(change('RecurrenceModalForm', 'RepeatInterval', this.state.RepeatInterval));
            this.props.dispatch(change('RecurrenceModalForm', 'RepeatValue', this.state.RepeatValue));
            this.props.dispatch(change('RecurrenceModalForm', 'MonthValue', this.state.MonthValue));
            this.props.dispatch(change('RecurrenceModalForm', 'StartDate', this.state.StartDate));
            this.props.dispatch(change('RecurrenceModalForm', 'EndDate', this.state.endDateForRecurrency));
            this.props.dispatch(change('RecurrenceModalForm', 'EnableEndDate_Switch', this.state.endDateEnabled));

            this.props.dispatch(change('RecurrenceModalForm', 'EndSelection', this.state.EndSelection));
            this.props.dispatch(change('RecurrenceModalForm', 'OccurrencesField', this.state.OccurrencesField));

            this.props.dispatch(change('RecurrenceModalForm', 'monthlyDayNumber', this.state.customMonthlyDayNumber));
            this.props.dispatch(change('RecurrenceModalForm', 'OrdinalPositionSelect', this.state.customSelectedMonthlyOrdinalPosition));
            this.props.dispatch(change('RecurrenceModalForm', 'MonthlyWeekDatSelect', this.state.customSelectedMonthlyRepetitionDay));
        }


    }

    // CheckValues=()=>{
    //     if(this.props.inputObj){

    //         const {StartDate, endDateForRecurrency, RepeatValue, repeatInterval, selectedWeekDays, EndSelection, OccurrencesField, customMonthlyDayNumber,
    //                 customMonthlyOptionSelected, customSelectedMonthlyOrdinalPosition, customSelectedMonthlyRepetitionDay} = this.props.inputObj;

    //         if((StartDate!==this.state.StartDate)
    //             ||(endDateForRecurrency !==this.state.endDateForRecurrency)
    //             ||(RepeatValue!==this.state.RepeatValue)
    //             ||(repeatInterval !==this.state.RepeatInterval)
    //         ){
    //             this.setState({enableSave:true})
    //         }
    //     }
    // }

    TitleComponent = () => {

        return (
            <Grid item container justify='left' alignContent='center' style={{ color: 'white', fontSize: '30px' }}>
                <Grid item>Recurrence</Grid>
            </Grid>
        )
    }

    ContentComponent = () => {
        return (
            <Grid item container justify='center' alignContent='flex-start' className='contentComponent' style={{ fontSize: '20px', height: '100%', overflow: 'auto' }}>
                <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                    <this.StartDateComponent />
                </Grid>
                {
                    this.state.RepeatValue ? "" :
                        <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                            <this.RepeatValueComponent />
                        </Grid>
                }
                <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                    <this.RepeatIntervalComponent />
                </Grid>
                {

                    (this.state.RepeatValue && this.state.RepeatValue.name === 'Weekly') ?
                        <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                            <this.WeeklyRepeatComponent />
                        </Grid>
                        :
                        undefined
                }
                {

                    (this.state.RepeatValue && (this.state.RepeatValue.name === 'Monthly' || this.state.RepeatValue.name === 'Yearly')) ?
                        <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                            <this.MonthlyRepeatComponent />
                        </Grid>
                        :
                        undefined
                }
                {
                    this.state.endDateEnabled ?
                        <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                            <this.EndComponent />
                        </Grid> :
                        <Grid item container ></Grid>
                }
                {
                    (this.state && this.state.EndSelection && this.state.EndSelection.name === 'After') ?
                        <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                            <this.OccurrencesComponent />
                        </Grid> :
                        <Grid item container ></Grid>
                }
                {
                    (this.state && this.state.EndSelection && this.state.EndSelection.name === 'On this date') ?
                        <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                            <this.EndDateComponent />
                        </Grid> :
                        <Grid item container ></Grid>
                }
                <Grid item container justify='center' alignContent='center' style={{ paddingTop: '20px' }}>
                    <this.LabelComponent />
                </Grid>
            </Grid>
        )
    }

    EndDateComponent = () => {
        return (
            <Grid item container>
                <this.DateComponent label={' '} name={'EndDate'} disabled={false} />
            </Grid>
        )
    }

    DateComponent = ({ label = undefined, name = undefined, disabled = false, onChangeHandler = undefined }) => {

        if (!name)
            return (<Grid item container></Grid>)

        let dateSelected = (name && name === 'StartDate' && this.state.StartDate) ? this.state.StartDate :
            (name && name === 'EndDate' && this.state.endDateForRecurrency) ? this.state.endDateForRecurrency :
                {};

        return (
            <Grid item container>
                <Grid item container xs={3} justify='flex-end' alignContent='center' className='padding15'>
                    <Grid item>{label}</Grid>
                </Grid>
                <Grid item container xs={1}>
                </Grid>
                <Grid item container xs={6} className='padding15' >
                    <Grid item container xs={12} justify='flex-start' alignContent='center'>
                        <Grid item>
                            {label === 'Start' && !this.props.enableStartDate ?
                                <Grid item xs={12} className="DateLabel">
                                    {dateSelected.format('MM/DD/yyyy')}
                                </Grid>
                                :
                                <Field
                                    name={name}
                                    labelDate={''}
                                    selectedDate={dateSelected} //most be an date object is use in both date and time
                                    onDateChange={(date) => this.onDateChangeHandler(date, label, name)}
                                    maxLength={20}
                                    component={renderSingleDatePicker}
                                    idToSet={name}
                                    disabled={disabled}
                                    id={name}
                                    inputClass='muiInputStyles'
                                />
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    StartDateComponent = () => {
        const disabledStartSate = this.props.enableStartDate ? false : true;

        return (
            <Grid item container>
                <this.DateComponent label={'Start'} name={'StartDate'} disabled={disabledStartSate} />
            </Grid>
        )
    }

    RepeatValueComponent = () => {
        return (
            <Grid item container>
                <Grid item container xs={3} justify='flex-end' alignContent='center' className='padding15'>
                    <Grid item>Repeat</Grid>
                </Grid>
                <Grid item container xs={1}>
                </Grid>
                <Grid item container xs={6} className='padding15' justify='flex-start' alignContent='center'>
                    <Grid item>
                        <Field
                            showStartAdornment={true}
                            name="RepeatValue"
                            label=""
                            maxLength={20}
                            selected={this.state.RepeatValue ? this.state.RepeatValue : { name: ' ' }}
                            optionsItemsIconsData={this.state.RepeatValueOptions ? this.state.RepeatValueOptions : [{ name: ' ' }]}
                            onChangeHandler={(e, newItem) => this.OnRepeatValueChangeHandler(e, newItem)}
                            component={renderSelect}
                            open={this.state.openRepeatValueCombo}
                            onClick={(e, option) => this.handleRepeatValueCombo(e, option)}
                            onBlur={() => this.handleRepeatValueOnBlur()}
                            autoCompleteStyles={{ paddingRight: '0px' }}
                            diableClear={true}
                            idToSet="RepeatValue"
                            id='RepeatValue'
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    onBlurIntervalField = () => {
        try {
            const intervalValue = this.state.RepeatInterval ? this.state.RepeatInterval : undefined;
            const repeatValue = this.state.RepeatValue ? this.state.RepeatValue : undefined;


            if (!intervalValue && repeatValue) {

                const NewIntervalValue = this.getDefaultRepeatValue(repeatValue);

                this.setState({ RepeatInterval: NewIntervalValue },
                    () => {
                        this.props.dispatch(change('RecurrenceModalForm', 'RepeatInterval', NewIntervalValue));
                        this.props.touch('RepeatInterval');
                    }
                );
            }
        } catch (err) { }
    }

    RepeatIntervalComponent = () => {
        return (
            <Grid item container  >
                <Grid item container xs={3} justify='flex-end' alignContent='center' className='padding15'>
                    <Grid item>
                        Every
                    </Grid>
                </Grid>
                <Grid item container xs={1}>
                </Grid>
                {
                    (this.state && this.state.RepeatValue && this.state.RepeatValue.name === 'Yearly') ?
                        <Grid item container xs={6} className='padding15' justify='flex-start' alignContent='center'>
                            <Grid item>
                                <Field
                                    showStartAdornment={true}
                                    name="MonthValue"
                                    label=""
                                    maxLength={20}
                                    selected={this.state.MonthValue ? this.state.MonthValue : { name: 'January', value: 0 }}
                                    optionsItemsIconsData={this.state.MonthValueOptions ? this.state.MonthValueOptions : [{ name: ' ' }]}
                                    onChangeHandler={(e, newItem) => this.OnMonthValueChangeHandler(e, newItem)}
                                    component={renderSelect}
                                    open={this.state.openMonthsValueCombo}
                                    onClick={(e, option) => this.handleMonthValueCombo(e, option)}
                                    onBlur={() => this.handleMonthValueOnBlur()}
                                    autoCompleteStyles={{ paddingRight: '0px' }}
                                    diableClear={true}
                                    idToSet="MonthValue"
                                    id='MonthValue'
                                />
                            </Grid>
                        </Grid> :
                        <Grid item container xs={6} className='padding15' justify='flex-start' alignContent='center'>
                            <Grid item xs={3} >
                                <Field
                                    name="RepeatInterval"
                                    label=""
                                    maxLength={3}
                                    valueToSet={this.state.RepeatInterval}
                                    onChange={(e, newInterval) => this.onRepeatIntervalChangeHandler(e, newInterval)}
                                    onBlur={() => this.onBlurIntervalField()}
                                    component={renderControledTextField}
                                    inputClass='muiInputStyles'
                                    id='RepeatInterval'
                                />
                            </Grid>
                            <Grid item container xs={2} alignItems='center'>
                                {
                                    (this.state && this.state.RepeatValue && this.state.RepeatValue.name === 'Daily') ?
                                        (this.state.RepeatInterval && this.state.RepeatInterval > 1) ? 'Days' : 'Day'
                                        :
                                        (this.state && this.state.RepeatValue && this.state.RepeatValue.name === 'Weekly') ?
                                            (this.state.RepeatInterval && this.state.RepeatInterval > 1) ? 'Weeks' : 'Week'
                                            :
                                            (this.state && this.state.RepeatValue && this.state.RepeatValue.name === 'Monthly') ?
                                                (this.state.RepeatInterval && this.state.RepeatInterval > 1) ? 'Months' : 'Month'
                                                :
                                                undefined
                                }
                            </Grid>
                        </Grid>
                }
            </Grid>
        )
    }

    getDefaultRepeatValue = (repeatValue) => {

        let defaultRepeatValue = 2;

        switch (repeatValue.name) {
            case 'Daily':
                defaultRepeatValue = 2;
                break;
            case 'Weekly':
                defaultRepeatValue = 4;
                break;
            case 'Yearly':
                defaultRepeatValue = 1;
                break;
            default:
                defaultRepeatValue = 2;
                break;
        }

        return defaultRepeatValue;
    }

    toggleSelectedDays = (day) => {
        const dayFound = (this.state.selectedWeekDays && this.state.selectedWeekDays.length > 0) ? this.state.selectedWeekDays.find(d => d.name === day.name) : undefined;
        let newSelectedDays = this.state.selectedWeekDays ? this.state.selectedWeekDays : [];

        if (dayFound) {
            newSelectedDays = newSelectedDays.filter(d => d.name !== day.name);
        } else {
            newSelectedDays.push(day);
        }

        /* Filtering */
        if (newSelectedDays.length > 1) {
            newSelectedDays = newSelectedDays.sort(function (a, b) {
                if (a.value > b.value) {
                    return 1;
                }
                if (a.value < b.value) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            });
        }
        this.setState({ selectedWeekDays: newSelectedDays })
    }

    WeekDayComponent = ({ day }) => {

        const daySelected = (this.state.selectedWeekDays && this.state.selectedWeekDays.length > 0) ? this.state.selectedWeekDays.find(d => d.name === day.name) : undefined;
        const selected = daySelected ? true : false;

        const dayFound = (this.state.weekDays && this.state.weekDays.length > 0) ? this.state.weekDays.find(d => d.name === day.name) : undefined;
        const initial = dayFound ? dayFound.short : ''

        if (!day || !initial)
            return (<Grid item></Grid>)
        const dayId = day ? day.name : "no-day";

        return (
            <Grid item container style={{ width: '14.27%' }} justify='center' alignContent='center' >
                <Grid id={dayId} item className={` weekDayRecurrenceModal ${selected ? 'weekDaySelectedRecurrenceModal' : undefined}`} onClick={() => this.toggleSelectedDays(day)} style={{ width: '80%', textAlign: 'center' }}>
                    {initial}
                </Grid>
            </Grid>
        )
    }

    WeeklyRepeatComponent = () => {
        return (
            <Grid item container>
                <Grid item container xs={3} justify='flex-end' alignContent='center' className='padding15'>On</Grid>
                <Grid item container xs={1}></Grid>
                <Grid item container xs={6} justify='flex-start'>
                    {
                        (this.state.weekDays && this.state.weekDays.length > 0) ?
                            this.state.weekDays.map(day => <this.WeekDayComponent day={day} />)
                            :
                            undefined
                    }
                </Grid>
            </Grid>
        )
    }

    onMonthlySelectionChange = (event) => {
        const value = (event && event.target && event.target.value) ? event.target.value : undefined;
        if (!value) return undefined;

        this.setState({ customMonthlyOptionSelected: Number(value) });
        this.props.dispatch(change('AddEventModal', 'optionSelected', value));
    }

    onMonthlyDayNumberChangeHandler = (e, newItem) => {
        let newValue = 1;
        const regex = new RegExp('^\\d+$');

        if (newItem && newItem.length > 0) {
            if (regex.test(newItem)) {
                const itemInt = parseInt(newItem);

                if (itemInt >= 1 && itemInt <= 31) {
                    newValue = newItem;
                    this.setState({ customMonthlyDayNumber: newValue })
                    this.props.dispatch(change('RecurrenceModalForm', 'monthlyDayNumber', newValue));
                }
            } else {
                newValue = this.state.customMonthlyDayNumber ? this.state.customMonthlyDayNumber : 1;
                this.setState({ customMonthlyDayNumber: newValue })
                this.props.dispatch(change('RecurrenceModalForm', 'monthlyDayNumber', newValue));
            }

        } else {
            newValue = '';
            this.setState({ customMonthlyDayNumber: newValue })
            this.props.dispatch(change('RecurrenceModalForm', 'monthlyDayNumber', newValue));
        }
    }

    MonthlyDayNumberComponent = () => {
        return (
            <Grid item container xs={12}>
                <Grid item container xs={4} md={2} alignContent='center' justify='flex-start' >
                    <Grid item>
                        Day
                    </Grid>
                </Grid>
                <Grid item container xs={4} alignContent='center' justify='flex-start' className='padding15'>
                    <Grid item container xs={12}>
                        <Grid item>
                            <Field
                                name="monthlyDayNumber"
                                label=""
                                maxLength={20}
                                valueToSet={this.state.customMonthlyDayNumber}
                                onChange={(e, newInterval) => this.onMonthlyDayNumberChangeHandler(e, newInterval)}
                                onBlur={() => this.onBlurIntervalField()}
                                component={renderControledTextField}
                                id='RepeatInterval'
                                disabled={(this.state.customMonthlyOptionSelected === 1) ? false : true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    onMonthlyOrdinalSelectionChange = (e, newItem) => {
        if (newItem && newItem.name && newItem.name.length > 0) {
            this.setState({ customSelectedMonthlyOrdinalPosition: newItem })
            this.handleMonthlyClickSelect(null, false);
        }
    }

    handleMonthlyClickSelect = (e, option) => {
        try {
            if (!option) {
                this.setState((prevState) => ({ openMonthlyOrdinalPositionSelect: !prevState.openMonthlyOrdinalPositionSelect }));
            } else {
                this.setState({ openMonthlyOrdinalPositionSelect: option });
            }
        } catch (err) { }
    }

    handlerOrdinalPositionSelectBlur = () => {
        try {
            setTimeout(() => {
                this.setState({ openMonthlyOrdinalPositionSelect: false })
            }, 50);
        } catch (err) { }
    }

    onMonthlyWeekdayChange = (e, newItem) => {
        if (newItem && newItem.name && newItem.name.length > 0) {
            this.setState({ customSelectedMonthlyRepetitionDay: newItem })
            this.handleMonthlyWeekdayClickSelect(null, false);
        }
    }

    handleMonthlyWeekdayClickSelect = (e, option) => {
        try {
            if (!option) {
                this.setState((prevState) => ({ openMonthlyWeekDaySelect: !prevState.openMonthlyWeekDaySelect }));
            } else {
                this.setState({ openMonthlyWeekDaySelect: option });
            }
        } catch (err) { }
    }

    handleMonthlyWeekdayClickSelectBlur = () => {
        try {
            setTimeout(() => {
                this.setState({ openMonthlyWeekDaySelect: false })
            }, 50);
        } catch (err) { }
    }


    MonthlyWeekDayComponent = () => {
        return (
            <Grid item container xs={12}>
                <Grid item container xs={2} alignContent='center' justify='flex-start'>
                    <Grid item>
                        The
                    </Grid>
                </Grid>
                <Grid item container xs={4} alignContent='center' justify='flex-start' className='padding15'>
                    <Grid item>
                        <Field
                            showStartAdornment={true}
                            name="OrdinalPositionSelect"
                            label=""
                            maxLength={20}
                            selected={this.state.customSelectedMonthlyOrdinalPosition ? this.state.customSelectedMonthlyOrdinalPosition : { name: ' ' }}
                            optionsItemsIconsData={this.state.monthlyOrdinalPosition ? this.state.monthlyOrdinalPosition : [{ name: ' ' }]}
                            onChangeHandler={(e, newItem) => this.onMonthlyOrdinalSelectionChange(e, newItem)}
                            component={renderSelect}
                            open={this.state.openMonthlyOrdinalPositionSelect}
                            onClick={(e, option) => this.handleMonthlyClickSelect(e, option)}
                            onBlur={() => this.handlerOrdinalPositionSelectBlur()}
                            autoCompleteStyles={{ paddingRight: '0px' }}
                            idToSet="OrdinalPositionSelect"
                            id='OrdinalPositionSelect'
                            disabled={(this.state.customMonthlyOptionSelected === 2) ? false : true}
                            diableClear={true}
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={6} alignContent='center' justify='flex-start' >
                    <Grid item>
                        <Field
                            showStartAdornment={true}
                            name="MonthlyWeekDatSelect"
                            label=""
                            maxLength={20}
                            selected={this.state.customSelectedMonthlyRepetitionDay ? this.state.customSelectedMonthlyRepetitionDay : { name: ' ' }}
                            optionsItemsIconsData={this.state.weekDays ? this.state.weekDays : [{ name: ' ' }]}
                            onChangeHandler={(e, newItem) => this.onMonthlyWeekdayChange(e, newItem)}
                            component={renderSelect}
                            open={this.state.openMonthlyWeekDaySelect}
                            onClick={(e, option) => this.handleMonthlyWeekdayClickSelect(e, option)}
                            onBlur={() => this.handleMonthlyWeekdayClickSelectBlur()}
                            autoCompleteStyles={{ paddingRight: '0px' }}
                            idToSet="MonthlyWeekDatSelect"
                            id='MonthlyWeekDatSelect'
                            disabled={(this.state.customMonthlyOptionSelected === 2) ? false : true}
                            diableClear={true}
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    MonthlyRepeatComponent = () => {
        const value = this.state.customMonthlyOptionSelected ? this.state.customMonthlyOptionSelected : 0
        return (
            <Grid item container>
                <Grid item container xs={3} justify='flex-end' className='padding15 paddingTop15'>On</Grid>
                <Grid item container xs={1}>
                </Grid>
                <Grid item container xs={8} justify='flex-start'>
                    <Grid item container xs={12}>
                        <Grid item container xs={2}>
                            <Radio
                                checked={value === 1}
                                onChange={this.onMonthlySelectionChange}
                                value='1'
                                name='radio-btn_onD'
                                icon={<RadioButtonUncheckedOutlinedIcon fontSize="large" style={value === 1 ? { color: '#009cda' } : { color: '#7a7979' }} />}
                                checkedIcon={<CheckCircleOutlinedIcon fontSize="large" style={value === 1 ? { color: '#009cda' } : { color: '#7a7979' }} />}
                            >
                            </Radio>
                        </Grid>
                        <Grid item container xs={10}>
                            <this.MonthlyDayNumberComponent />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item container xs={2} >
                            <Radio
                                checked={value === 2}
                                onChange={this.onMonthlySelectionChange}
                                value='2'
                                name='radio-btn_onT'
                                icon={<RadioButtonUncheckedOutlinedIcon fontSize="large" style={value === 2 ? { color: '#009cda' } : { color: '#7a7979' }} />}
                                checkedIcon={<CheckCircleOutlinedIcon fontSize="large" style={value === 2 ? { color: '#009cda' } : { color: '#7a7979' }} />}
                            >
                            </Radio>
                        </Grid>
                        <Grid item container xs={10} >
                            <this.MonthlyWeekDayComponent />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    onEndValueChangeHandler = (e, newItem) => {
        try {
            this.setState({ EndSelection: newItem, occurrencesToEnd: this.GetDefaultOcurrences() });
            this.props.dispatch(change('RecurrenceModalForm', 'EndSelection', newItem));
            this.handleEndCombo(null, false);
        } catch (err) { }
    }

    GetDefaultOcurrences = (newItem = undefined) => {
        const repeatValueSelected = newItem ? newItem : (this.state.RepeatValue) ? this.state.RepeatValue : undefined;
        let defaultOccurences = 1;

        switch (repeatValueSelected.name) {
            case 'Daily':
                defaultOccurences = 24;
                break;
            case 'Weekly':
                defaultOccurences = 5;
                break;
            case 'Yearly':
                defaultOccurences = 4;
                break;
            default:
                defaultOccurences = 1;
                break;
        }

        return defaultOccurences;
    }

    handleEndCombo = (e, option) => {
        try {
            if (!option) {
                this.setState((prevState) => ({ openEndCombo: !prevState.openEndCombo }));
            } else {
                this.setState({ openEndCombo: option });
            }
        } catch (err) { }
    }
    handleEndOnBlur = () => {
        try {
            setTimeout(() => {
                this.setState({ openEndCombo: false })
            }, 50);
        } catch (err) { }
    }


    EndComponent = () => {
        return (
            <Grid item container>
                <Grid item container xs={3} justify='flex-end' alignContent='center' className='padding15'>
                    <Grid item>End</Grid>
                </Grid>
                <Grid item container xs={1}>
                </Grid>
                <Grid item container xs={6} className='padding15' justify='flex-end' alignContent='center'>
                    <Field
                        showStartAdornment={true}
                        name="EndSelection"
                        label=""
                        maxLength={20}
                        selected={this.state.EndSelection ? this.state.EndSelection : { name: ' ' }}
                        optionsItemsIconsData={this.state.endValuesOptions ? this.state.endValuesOptions : [{ name: ' ' }]}
                        onChangeHandler={(e, newItem) => this.onEndValueChangeHandler(e, newItem)}
                        component={renderSelect}
                        open={this.state.openEndCombo}
                        onClick={(e, option) => this.handleEndCombo(e, option)}
                        onBlur={() => this.handleEndOnBlur()}
                        autoCompleteStyles={{ paddingRight: '0px' }}
                        diableClear={true}
                        idToSet="EndSelection"
                        id='EndSelection'
                    />
                </Grid>
            </Grid>
        )
    }


    onOccurrencesChangeHandler = (e, newInterval) => {

        let newValue = '';
        const regex = new RegExp('^\\d+$');

        if (newInterval && newInterval > 0) {

            if (regex.test(newInterval)) {
                newValue = newInterval;
                this.setState({ OccurrencesField: newValue })
            } else {
                newValue = this.state.OccurrencesField ? this.state.OccurrencesField : 1;
                this.setState({ OccurrencesField: newValue })
            }
        } else {
            newValue = "";
            this.setState({ OccurrencesField: newValue })
        }

        this.props.dispatch(change('RecurrenceModalForm', 'OccurrencesField', newValue));
    }

    onBlurOccurrencesField = () => {
        try {
            const oldRepeatValue = this.state.RepeatValue ? this.state.RepeatValue : undefined;
            const oldOccurrencesField = this.state.OccurrencesField ? this.state.OccurrencesField : undefined;

            if (!oldOccurrencesField && oldRepeatValue) {

                const newOcurrencesValue = this.GetDefaultOcurrences(oldRepeatValue);

                this.setState({ OccurrencesField: newOcurrencesValue },
                    () => {
                        this.props.dispatch(change('RecurrenceModalForm', 'OccurrencesField', newOcurrencesValue));
                        this.props.touch('OccurrencesField')
                    });


            }
        } catch (err) { }
    }

    OccurrencesComponent = () => {
        return (
            <Grid item container >
                <Grid item container xs={3} justify='flex-end' alignContent='center' className='padding15'>

                </Grid>
                <Grid item container xs={1}>
                </Grid>
                <Grid item container xs={2} className='padding15' justify='flex-end' alignContent='center'>
                    <Field
                        name="OccurrencesField"
                        label=""
                        maxLength={3}
                        valueToSet={this.state.OccurrencesField}
                        onChange={(e, newInterval) => this.onOccurrencesChangeHandler(e, newInterval)}
                        onBlur={() => this.onBlurOccurrencesField()}
                        component={renderControledTextField}
                        inputClass='muiInputStyles'
                        id='OccurrencesField'
                    />
                </Grid>
                <Grid item container xs={3} justify='flex-start' alignContent='center' className='padding15'>
                    <Grid item>Occurrences</Grid>
                </Grid>
            </Grid>
        )
    }

    LabelComponent = () => {

        let label = '';
        let typeLabel = this.state.RepeatValue ? this.state.RepeatValue.name : 'days';

        switch (typeLabel) {
            case 'Daily':
                typeLabel = 'days'
                break;
            case 'Weekly':
                typeLabel = 'weeks'
                break;
            case 'Monthly':
                typeLabel = 'months'
                break;
            case 'Yearly':
                typeLabel = 'years'
                break;
            default:
                typeLabel = 'days'
                break;
        }

        let daysLabel = (this.state.RepeatInterval && this.state.RepeatInterval > 1) ? `${this.state.RepeatInterval} ${typeLabel}` : typeLabel.replace('s', '');


        const tz = this.state.tz
        const startDate = this.state.StartDate ? moment.tz(this.state.StartDate, tz).startOf('day') : undefined;
        const repeatValue = (this.state.RepeatValue && this.state.RepeatValue.name && this.state.RepeatValue.name.length > 0) ? this.state.RepeatValue : undefined;
        const repeatInterval = (this.state.RepeatInterval && this.state.RepeatInterval > 0) ? this.state.RepeatInterval : undefined;
        const EndSelection = (this.state.EndSelection && this.state.EndSelection.name && this.state.EndSelection.name.length > 0) ? this.state.EndSelection : undefined

        let OccurrencesField = (this.state.OccurrencesField && this.state.OccurrencesField > 0) ? this.state.OccurrencesField : undefined;
        let EndDate = (this.state.endDateForRecurrency) ? moment(this.state.endDateForRecurrency, tz).startOf('day') : undefined;
        let daysToAdd = 0;
        let actualDay = new moment(startDate).clone();

        if (startDate && EndSelection && repeatValue && repeatInterval) {
            let numberOfRepetitions = repeatInterval * (OccurrencesField - 1);

            if (EndSelection.name === 'After' && OccurrencesField) {
                const startMoment = new moment(startDate).clone();
                switch (repeatValue.name.toLowerCase()) {
                    case 'daily':
                        EndDate = startMoment.clone().add(numberOfRepetitions, 'd');
                        break;
                    case 'weekly':
                        let selectedDays = this.state.selectedWeekDays ? this.state.selectedWeekDays : [];
                        let dpw = selectedDays.length;

                        if (!(selectedDays.filter(day => day.value >= actualDay.day())[0])) {
                            actualDay = actualDay.clone().add(1, 'w');
                            actualDay = actualDay.clone().startOf('w');
                        }

                        if (dpw > 0) {
                            while (OccurrencesField > 0) {
                                let Day = actualDay.day();
                                if (OccurrencesField > dpw) {
                                    OccurrencesField = OccurrencesField - selectedDays.filter(day => day.value >= Day).length;
                                    actualDay = actualDay.clone().add(repeatInterval, 'w');
                                    actualDay = actualDay.clone().startOf('w');
                                } else {
                                    actualDay = actualDay.clone().add(selectedDays[OccurrencesField - 1].value, 'd');
                                    OccurrencesField = 0;
                                }
                            }
                        }
                        EndDate = actualDay;
                        break;
                    case 'monthly':
                        let customMonthlyOptionSelected = (this.state.customMonthlyOptionSelected) ? this.state.customMonthlyOptionSelected : 0;
                        let customMonthlyDayNumber = (this.state.customMonthlyDayNumber) ? this.state.customMonthlyDayNumber : 1;
                        let customSelectedMonthlyOrdinalPosition = (this.state.customSelectedMonthlyOrdinalPosition) ? this.state.customSelectedMonthlyOrdinalPosition : undefined;
                        let customSelectedMonthlyRepetitionDay = (this.state.customSelectedMonthlyRepetitionDay) ? this.state.customSelectedMonthlyRepetitionDay : undefined;

                        if (customMonthlyOptionSelected === 1) {
                            daysToAdd = customMonthlyDayNumber;
                        } else if (customMonthlyOptionSelected === 2) {
                            if (customSelectedMonthlyOrdinalPosition.order === 5) {
                                let endOfMonth = actualDay.clone().endOf('month');

                                if (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                    while (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                        endOfMonth = endOfMonth.clone().subtract(1, 'day');
                                    }
                                }
                                daysToAdd = endOfMonth.date();
                            } else {
                                let scheduleMonthDate = this.nthWeekdayOfMonth(actualDay.year(), actualDay.month() + 1, customSelectedMonthlyOrdinalPosition.order, customSelectedMonthlyRepetitionDay.value);
                                daysToAdd = scheduleMonthDate.getDate();
                            }
                        }

                        if (daysToAdd !== actualDay.date()) {
                            if (!(daysToAdd > actualDay.date()))
                                numberOfRepetitions = numberOfRepetitions + 1;
                        }

                        EndDate = startMoment.clone().add(numberOfRepetitions, 'M');
                        if (this.state.customMonthlyOptionSelected === 1) {
                            EndDate = EndDate.set({ 'date': this.state.customMonthlyDayNumber });
                        }

                        if (this.state.customMonthlyOptionSelected === 2) {
                            if (this.state.customSelectedMonthlyOrdinalPosition.order === 5) {
                                EndDate = EndDate.clone().endOf('month');

                                if (EndDate.day() !== this.state.customSelectedMonthlyRepetitionDay.value) {
                                    while (EndDate.day() !== this.state.customSelectedMonthlyRepetitionDay.value) {
                                        EndDate = EndDate.clone().subtract(1, 'day');
                                    }
                                }
                            } else {
                                let scheduleMonthDate = this.nthWeekdayOfMonth(EndDate.year(), EndDate.month() + 1, this.state.customSelectedMonthlyOrdinalPosition.order, this.state.customSelectedMonthlyRepetitionDay.value);
                                EndDate = EndDate.set({ 'year: ': scheduleMonthDate.getFullYear(), 'month': scheduleMonthDate.getMonth(), 'date': scheduleMonthDate.getDate() });
                            }
                        }
                        break;
                    case 'yearly':
                        if (actualDay.month() > this.state.MonthValue.value)
                            numberOfRepetitions = numberOfRepetitions + 1;
                        else {
                            let customMonthlyOptionSelected = (this.state.customMonthlyOptionSelected) ? this.state.customMonthlyOptionSelected : 0;
                            let customMonthlyDayNumber = (this.state.customMonthlyDayNumber) ? this.state.customMonthlyDayNumber : 1;
                            let customSelectedMonthlyOrdinalPosition = (this.state.customSelectedMonthlyOrdinalPosition) ? this.state.customSelectedMonthlyOrdinalPosition : undefined;
                            let customSelectedMonthlyRepetitionDay = (this.state.customSelectedMonthlyRepetitionDay) ? this.state.customSelectedMonthlyRepetitionDay : undefined;

                            if (customMonthlyOptionSelected === 1) {
                                daysToAdd = customMonthlyDayNumber;
                            } else if (customMonthlyOptionSelected === 2) {
                                if (customSelectedMonthlyOrdinalPosition.order === 5) {
                                    let endOfMonth = actualDay.clone().endOf('month');

                                    if (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                        while (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                            endOfMonth = endOfMonth.clone().subtract(1, 'day');
                                        }
                                    }
                                    daysToAdd = endOfMonth.date();
                                } else {
                                    let scheduleMonthDate = this.nthWeekdayOfMonth(actualDay.year(), actualDay.month() + 1, customSelectedMonthlyOrdinalPosition.order, customSelectedMonthlyRepetitionDay.value);
                                    daysToAdd = scheduleMonthDate.getDate();
                                }
                            }
                            if (actualDay.month() === this.state.MonthValue.value) {
                                if (daysToAdd !== actualDay.date()) {
                                    if (!(daysToAdd > actualDay.date()))
                                        numberOfRepetitions = numberOfRepetitions + 1;
                                }
                            }
                        }

                        EndDate = startMoment.clone().add(numberOfRepetitions, 'Y');
                        EndDate = EndDate.set({ 'month': this.state.MonthValue.value });
                        if (this.state.customMonthlyOptionSelected === 1) {
                            EndDate = EndDate.set({ 'date': this.state.customMonthlyDayNumber });
                        }

                        if (this.state.customMonthlyOptionSelected === 2) {
                            if (this.state.customSelectedMonthlyOrdinalPosition.order === 5) {
                                EndDate = EndDate.clone().endOf('month');

                                if (EndDate.day() !== this.state.customSelectedMonthlyRepetitionDay.value) {
                                    while (EndDate.day() !== this.state.customSelectedMonthlyRepetitionDay.value) {
                                        EndDate = EndDate.clone().subtract(1, 'day');
                                    }
                                }
                            } else {
                                let scheduleMonthDate = this.nthWeekdayOfMonth(EndDate.year(), EndDate.month() + 1, this.state.customSelectedMonthlyOrdinalPosition.order, this.state.customSelectedMonthlyRepetitionDay.value);
                                EndDate = EndDate.set({ 'year: ': scheduleMonthDate.getFullYear(), 'month': scheduleMonthDate.getMonth(), 'date': scheduleMonthDate.getDate() });
                            }
                        }
                        break;
                    default: break;
                }

            } else if (EndSelection.name === 'On this date' && EndDate) {
                const testStartDate = startDate.clone();
                let newOccurrences = 0;
                switch (repeatValue.name.toLowerCase()) {
                    case 'daily':
                        while (testStartDate <= EndDate) {
                            newOccurrences = newOccurrences + 1;
                            testStartDate.add(repeatInterval, 'd');
                        }
                        break;
                    case 'weekly':
                        while (testStartDate <= EndDate) {
                            newOccurrences = newOccurrences + 1;
                            testStartDate.add(repeatInterval, 'w');
                        }
                        break;
                    case 'monthly':
                        while (testStartDate <= EndDate) {
                            newOccurrences = newOccurrences + 1;
                            testStartDate.add(repeatInterval, 'M');
                        }
                        break;
                    case 'yearly':
                        while (testStartDate <= EndDate) {
                            newOccurrences = newOccurrences + 1;
                            testStartDate.add(repeatInterval, 'Y');
                        }
                        break;
                    default: break;
                }
                OccurrencesField = newOccurrences;
            }
        }

        if (startDate instanceof moment && startDate && this.state.RepeatInterval && this.state.RepeatInterval > 0) {
            label = this.getOccurrenceLabel(daysLabel, startDate, EndDate);
        }

        return (
            <Grid item container justify='flex-start' alignContent='center'>
                <Grid id='recurrence-modal-label' item style={{ fontSize: '14px' }}>
                    {label}
                </Grid>
            </Grid>
        )
    }

    getOccurrenceLabel = (daysLabel, startD, EndDate) => {
        let label = '';

        switch (this.state.RepeatValue.name) {
            case 'Daily':
                label = `Occurs every ${daysLabel} starting ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;
                break;
            case 'Weekly':
                let daysSelectedLabel = '';
                this.state.selectedWeekDays.forEach(weekDay => { daysSelectedLabel += ` ${weekDay.name},` });
                daysSelectedLabel = daysSelectedLabel.replace(/,\s*$/, "");
                if (daysSelectedLabel.length > 0) {
                    label = `Occurs every ${daysLabel} on ${daysSelectedLabel} from ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;
                } else {
                    label = ``;
                }
                break;
            case 'Monthly':
                if (this.state.customMonthlyOptionSelected === undefined)
                    label = '';

                if (this.state.customMonthlyOptionSelected === 1 && this.state.customMonthlyDayNumber !== '')
                    label = `Occurs day ${this.state.customMonthlyDayNumber} of every ${daysLabel} starting ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;

                if (this.state.customMonthlyOptionSelected === 2)
                    label = `Occurs the ${this.state.customSelectedMonthlyOrdinalPosition.name.toLowerCase()} ${this.state.customSelectedMonthlyRepetitionDay.name} of every ${daysLabel} starting ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;

                break;
            case 'Yearly':
                if (this.state.customMonthlyOptionSelected === undefined)
                    label = '';

                if (this.state.customMonthlyOptionSelected === 1 && this.state.customMonthlyDayNumber !== '')
                    label = `Occurs every ${this.state.MonthValue.name} ${this.state.customMonthlyDayNumber} starting ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;

                if (this.state.customMonthlyOptionSelected === 2)
                    label = `Occurs the ${this.state.customSelectedMonthlyOrdinalPosition.name.toLowerCase()} ${this.state.customSelectedMonthlyRepetitionDay.name} of ${this.state.MonthValue.name} starting ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;

                break;
            default:
                label = `Occurs day ${daysLabel} starting ${moment(startD).format("MMMM D, YYYY")}, to ${moment(EndDate).format("MMMM D, YYYY")}.`;
                break;
        }

        return label;
    }

    nthWeekdayOfMonth = (year, month, nth, dow) => {
        const d = new Date(year, month - 1, 7 * (nth - 1) + 1);
        const w = d.getDay();
        d.setDate(d.getDate() + (7 + dow - w) % 7);
        return d;
    }

    ButtonsComponent = () => {

        let saveAvailable = false;

        switch (this.state.RepeatValue.name) {
            case 'Daily':
                if ((this.state.EndSelection.name === 'On this date' && this.state.endDateForRecurrency !== undefined) || this.state.EndSelection.name === 'After')
                    saveAvailable = true;
                break;
            case 'Weekly':
                if (this.state.selectedWeekDays.length > 0 && ((this.state.EndSelection.name === 'On this date' && this.state.endDateForRecurrency !== undefined) || this.state.EndSelection.name === 'After'))
                    saveAvailable = true;
                break;
            case 'Monthly':
            case 'Yearly':
                if (this.state.customMonthlyOptionSelected !== undefined && ((this.state.EndSelection.name === 'On this date' && this.state.endDateForRecurrency !== undefined) || this.state.EndSelection.name === 'After'))
                    saveAvailable = true;
                if (this.state.customMonthlyOptionSelected === 1 && this.state.customMonthlyDayNumber === '')
                    saveAvailable = false;
                break;
            default:
                saveAvailable = false
                break;
        }

        return (
            <Grid item container alignContent='center' justify='flex-end'>
                <Grid item style={{ paddingRight: '10px' }}>
                    <Grid
                        id='cancelRecurrence'
                        className='appbtn-engage greyCancelBtn-engage appbtnBarButton'
                        onClick={this.closeModal}
                    >
                        Cancel
                    </Grid>
                </Grid>
                <Grid item style={{ paddingRight: '0px' }}>
                    <Grid
                        id='saveRecurrenceObj'
                        className={saveAvailable ? 'appbtn-engage skybluebtn-engage appbtnBarButton' : 'appbtn-engage skybluebtn-engage appbtnBarButton appbtn-engage disabledSkybluebtn-engage'}
                        onClick={saveAvailable ? this.props.handleSubmit(this.onSubmitHandler.bind(this)) : ''}
                    >
                        Save
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    EndDateSwitchComponent = () => {
        return (
            <Grid item container justify='center' alignContent='center'>
                <Grid item xs={12} style={{ padding: '10px' }}>
                    <Field
                        id='EnableEndDate_Switch'
                        idToSet='EnableEndDate_Switch'
                        name="EnableEndDate_Switch"
                        label="End"
                        checked={this.state.endDateEnabled}
                        onClick={this.EndDateSwitchChangeHandler}
                        component={renderSwitchWithLabel}
                        stylesLabel={{ fontWeight: 'bold', textAlign: 'left' }}
                    />
                </Grid>
            </Grid>)
    }

    closeModal = () => {
        this.setState({
            inputObj: undefined,
            openModal: false,
            onSetDateHandler: undefined,

            //selected values
            StartDate: undefined,
            endDateForRecurrency: undefined,
            RepeatInterval: 2,
            OccurrenceLabel: ''
        });

        this.state.onCloseModalHandler();
    }

    onDateChangeHandler = (date, label, name) => {
        if (!name)
            return undefined

        switch (name.toLowerCase()) {
            case 'startdate':
                this.setState({ StartDate: date })
                break;
            case 'enddate':
                this.setState({ endDateForRecurrency: date })
                break;
            default:
                break;
        }

        this.props.dispatch(change('RecurrenceModalForm', name, date));
    }


    onRepeatIntervalChangeHandler = (e, newInterval) => {


        let newValue = 1;
        const regex = new RegExp('^\\d+$');

        if (newInterval && newInterval > 0) {
            if (regex.test(newInterval)) {
                newValue = newInterval;
                this.setState({ RepeatInterval: newValue })
            } else {
                newValue = this.state.RepeatInterval ? this.state.RepeatInterval : 1;
                this.setState({ RepeatInterval: newValue })
            }

        } else {
            newValue = "";
            this.setState({ RepeatInterval: newValue })
        }


        this.props.dispatch(change('RecurrenceModalForm', 'RepeatInterval', newValue));
    }

    OnRepeatValueChangeHandler = (e, newItem) => {
        try {

            this.setState({ RepeatValue: newItem, RepeatInterval: this.getDefaultRepeatValue(newItem), OccurrencesField: this.GetDefaultOcurrences(newItem) });
            this.props.dispatch(change('RecurrenceModalForm', 'RepeatValue', newItem));
            this.handleRepeatValueCombo(null, false);
        } catch (err) { }
    }


    handleRepeatValueCombo = (e, option) => {
        try {
            if (!option) {
                this.setState((prevState) => ({ openRepeatValueCombo: !prevState.openRepeatValueCombo }));
            } else {
                this.setState({ openRepeatValueCombo: option });
            }
        } catch (err) { }
    }
    handleRepeatValueOnBlur = () => {
        try {
            setTimeout(() => {
                this.setState({ openRepeatValueCombo: false })
            }, 50);
        } catch (err) { }
    }


    OnMonthValueChangeHandler = (e, newItem) => {
        try {

            this.setState({ MonthValue: newItem });
            this.props.dispatch(change('RecurrenceModalForm', 'MonthValue', newItem));
            this.handleMonthValueCombo(null, false);
        } catch (err) { }
    }


    handleMonthValueCombo = (e, option) => {
        try {
            if (!option) {
                this.setState((prevState) => ({ openMonthsValueCombo: !prevState.openMonthsValueCombo }));
            } else {
                this.setState({ openMonthsValueCombo: option });
            }
        } catch (err) { }
    }
    handleMonthValueOnBlur = () => {
        try {
            setTimeout(() => {
                this.setState({ openMonthsValueCombo: false })
            }, 50);
        } catch (err) { }
    }

    onSubmitHandler = async (formData) => {
        try {
            const newIntRepeatInterval = (this.state.RepeatInterval && !isNaN(parseInt(this.state.RepeatInterval))) ? parseInt(this.state.RepeatInterval) : 0;
            let newIntOccurrences = undefined;
            let newEndDate = this.state.endDateForRecurrency ? this.state.endDateForRecurrency : undefined;
            let startDate = this.state.StartDate ? moment(this.state.StartDate).startOf('day') : undefined;
            //weekly
            let selectedWeekDays = this.state.selectedWeekDays ? this.state.selectedWeekDays : undefined;

            //monthly
            let customMonthlyOptionSelected = (this.state.customMonthlyOptionSelected) ? this.state.customMonthlyOptionSelected : 0;
            let customMonthlyDayNumber = undefined;
            let customSelectedMonthlyOrdinalPosition = undefined;
            let customSelectedMonthlyRepetitionDay = undefined;

            //yearly
            const MonthValue = (this.state.MonthValue) ? this.state.MonthValue : { name: 'January', value: 0 };

            const EndSelection = (this.state.EndSelection) ? this.state.EndSelection : undefined;
            if (EndSelection && EndSelection.name && EndSelection.name.length) {
                switch (EndSelection.name.toLowerCase()) {
                    case 'after':
                        newIntOccurrences = (this.state.OccurrencesField && !isNaN(parseInt(this.state.OccurrencesField))) ? parseInt(this.state.OccurrencesField) : 0;

                        break;
                    default:
                        break;
                }
            }
            const RepeatValue = (this.state.RepeatValue) ? this.state.RepeatValue : undefined;
            let repetitions = newIntRepeatInterval * ((newIntOccurrences && newIntOccurrences > 1) ? newIntOccurrences - 1 : newIntOccurrences);
            let initialRecurrenceDate = undefined;
            let daysToAdd = 0;
            let actualDay = new moment(startDate);

            if (RepeatValue && RepeatValue.name && RepeatValue.name.length > 0) {
                switch (RepeatValue.name.toLowerCase()) {
                    case 'daily':
                        if (!this.state.endDateForRecurrency || EndSelection.name.toLowerCase() === 'after') {
                            newEndDate = new moment(startDate).add(repetitions, 'd');
                        }
                        break;
                    case 'weekly':
                        let selectedDays = this.state.selectedWeekDays ? this.state.selectedWeekDays : [];
                        let OccurrencesField = newIntOccurrences;
                        if (selectedDays.filter(day => day.value >= actualDay.day())[0])
                            daysToAdd = selectedDays.filter(day => day.value >= actualDay.day())[0].value - actualDay.day();
                        else {
                            daysToAdd = (7 - actualDay.day()) + selectedDays.filter(day => day.value <= actualDay.day())[0].value;
                            actualDay = actualDay.clone().add(1, 'w');
                            actualDay = actualDay.clone().startOf('w');
                        }

                        if (daysToAdd > 0)
                            initialRecurrenceDate = startDate.clone().add(daysToAdd, 'd').toDate();

                        if (!this.state.endDateForRecurrency || EndSelection.name.toLowerCase() === 'after') {
                            let dpw = selectedDays.length;

                            if (dpw > 0) {
                                while (OccurrencesField > 0) {
                                    let Day =actualDay.day()
                                    if (OccurrencesField > dpw) {
                                        OccurrencesField = OccurrencesField - (selectedDays.filter(day => day.value >= Day).length);
                                        actualDay = actualDay.clone().add(newIntRepeatInterval, 'w');
                                        actualDay = actualDay.clone().startOf('w');

                                    } else {
                                        actualDay = actualDay.clone().add(selectedDays[OccurrencesField - 1].value, 'd');
                                        OccurrencesField = 0;
                                    }
                                }
                            }
                            newEndDate = actualDay;
                        }

                        break;
                    case 'monthly':
                        customMonthlyDayNumber = (this.state.customMonthlyDayNumber) ? this.state.customMonthlyDayNumber : 1;
                        customSelectedMonthlyOrdinalPosition = (this.state.customSelectedMonthlyOrdinalPosition) ? this.state.customSelectedMonthlyOrdinalPosition : undefined;
                        customSelectedMonthlyRepetitionDay = (this.state.customSelectedMonthlyRepetitionDay) ? this.state.customSelectedMonthlyRepetitionDay : undefined;
                        let initialDateCorrect = false;

                        if (customMonthlyOptionSelected === 1) {
                            daysToAdd = customMonthlyDayNumber;

                            if (daysToAdd !== actualDay.date()) {
                                if (daysToAdd > actualDay.date())
                                    initialRecurrenceDate = startDate.clone().set({ 'date': daysToAdd }).toDate();
                                else {
                                    repetitions = repetitions + 1;
                                    initialRecurrenceDate = startDate.clone().set({ 'month': actualDay.month() + 1, 'date': daysToAdd }).toDate();
                                }
                            }
                        } else if (customMonthlyOptionSelected === 2) {
                            let initialDate = actualDay.clone();
                            while (!initialDateCorrect) {
                                if (customSelectedMonthlyOrdinalPosition.order === 5) {
                                    let endOfMonth = actualDay.clone().endOf('month');

                                    if (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                        while (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                            endOfMonth = endOfMonth.clone().subtract(1, 'day');
                                        }
                                    }
                                    initialRecurrenceDate = actualDay.clone().set({ 'date': endOfMonth.date() }).toDate();
                                } else {
                                    let scheduleMonthDate = this.nthWeekdayOfMonth(actualDay.year(), actualDay.month() + 1, customSelectedMonthlyOrdinalPosition.order, customSelectedMonthlyRepetitionDay.value);
                                    initialRecurrenceDate = scheduleMonthDate;
                                }

                                if (initialRecurrenceDate < initialDate) {
                                    repetitions = repetitions + 1;
                                    actualDay = actualDay.clone().add(1, 'month');
                                } else {
                                    initialDateCorrect = true;
                                }
                            }
                        }

                        if (!this.state.endDateForRecurrency || EndSelection.name.toLowerCase() === 'after') {
                            newEndDate = moment(startDate).clone().add(repetitions, 'M');
                            if (customMonthlyOptionSelected === 1) {
                                newEndDate = newEndDate.set({ 'date': customMonthlyDayNumber });
                            } else if (customMonthlyOptionSelected === 2) {
                                if (customSelectedMonthlyOrdinalPosition.order === 5) {
                                    newEndDate = newEndDate.clone().endOf('month');

                                    if (newEndDate.day() !== customSelectedMonthlyRepetitionDay.value) {
                                        while (newEndDate.day() !== customSelectedMonthlyRepetitionDay.value) {
                                            newEndDate = newEndDate.clone().subtract(1, 'day');
                                        }
                                    }
                                } else {
                                    let scheduleMonthDate = this.nthWeekdayOfMonth(newEndDate.year(), newEndDate.month() + 1, customSelectedMonthlyOrdinalPosition.order, customSelectedMonthlyRepetitionDay.value);
                                    newEndDate = newEndDate.set({ 'year: ': scheduleMonthDate.getFullYear(), 'month': scheduleMonthDate.getMonth(), 'date': scheduleMonthDate.getDate() });
                                }
                            }
                        }
                        break;

                    case 'yearly':
                        customMonthlyDayNumber = (this.state.customMonthlyDayNumber) ? this.state.customMonthlyDayNumber : 1;
                        customSelectedMonthlyOrdinalPosition = (this.state.customSelectedMonthlyOrdinalPosition) ? this.state.customSelectedMonthlyOrdinalPosition : undefined;
                        customSelectedMonthlyRepetitionDay = (this.state.customSelectedMonthlyRepetitionDay) ? this.state.customSelectedMonthlyRepetitionDay : undefined;
                        let MonthValidation = actualDay.month() === this.state.MonthValue.value ? true : false;

                        if (actualDay.month() > this.state.MonthValue.value) {
                            repetitions = repetitions + 1;
                            actualDay = actualDay.add(1, 'Y');
                        }

                        if (actualDay.month() !== this.state.MonthValue.value)
                            actualDay = actualDay.set({ 'month': this.state.MonthValue.value });

                        if (customMonthlyOptionSelected === 1) {
                            daysToAdd = customMonthlyDayNumber;
                        } else if (customMonthlyOptionSelected === 2) {
                            if (customSelectedMonthlyOrdinalPosition.order === 5) {
                                let endOfMonth = actualDay.clone().endOf('month');

                                if (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                    while (endOfMonth.day() !== customSelectedMonthlyRepetitionDay.value) {
                                        endOfMonth = endOfMonth.clone().subtract(1, 'day');
                                    }
                                }
                                daysToAdd = endOfMonth.date();
                            } else {
                                let scheduleMonthDate = this.nthWeekdayOfMonth(actualDay.year(), actualDay.month() + 1, customSelectedMonthlyOrdinalPosition.order, customSelectedMonthlyRepetitionDay.value);
                                daysToAdd = scheduleMonthDate.getDate();
                            }
                        }

                        if (daysToAdd !== actualDay.date()) {
                            if (daysToAdd > actualDay.date())
                                initialRecurrenceDate = actualDay.clone().set({ 'date': daysToAdd }).toDate();
                            else {
                                if (MonthValidation)
                                    repetitions = repetitions + 1;
                                initialRecurrenceDate = actualDay.clone().set({ 'month': actualDay.month(), 'date': daysToAdd }).toDate();
                            }
                        } else if (!MonthValidation)
                            initialRecurrenceDate = actualDay.clone().set({ 'month': actualDay.month() }).toDate();


                        if (!this.state.endDateForRecurrency || EndSelection.name.toLowerCase() === 'after') {
                            newEndDate = moment(startDate).clone().add(repetitions, 'Y');
                            newEndDate = newEndDate.set({ 'month': this.state.MonthValue.value });
                            if (customMonthlyOptionSelected === 1) {
                                newEndDate = newEndDate.set({ 'date': customMonthlyDayNumber });
                            } else if (customMonthlyOptionSelected === 2) {
                                if (this.state.customSelectedMonthlyOrdinalPosition.order === 5) {
                                    newEndDate = newEndDate.clone().endOf('month');

                                    if (newEndDate.day() !== customSelectedMonthlyRepetitionDay.value) {
                                        while (newEndDate.day() !== customSelectedMonthlyRepetitionDay.value) {
                                            newEndDate = newEndDate.clone().subtract(1, 'day');
                                        }
                                    }
                                } else {
                                    let scheduleMonthDate = this.nthWeekdayOfMonth(newEndDate.year(), newEndDate.month() + 1, customSelectedMonthlyOrdinalPosition.order, customSelectedMonthlyRepetitionDay.value);
                                    newEndDate = newEndDate.set({ 'year: ': scheduleMonthDate.getFullYear(), 'month': scheduleMonthDate.getMonth(), 'date': scheduleMonthDate.getDate() });
                                }
                            }
                        }
                        break;
                    default:
                        break;
                }
            }

            let typeLabel = this.state.RepeatValue ? this.state.RepeatValue.name : 'days';
            switch (typeLabel) {
                case 'Daily':
                    typeLabel = 'days'
                    break;
                case 'Weekly':
                    typeLabel = 'weeks'
                    break;
                case 'Monthly':
                    typeLabel = 'months'
                    break;
                case 'Yearly':
                    typeLabel = 'years'
                    break;
                default:
                    typeLabel = 'days'
                    break;
            }

            let daysLabel = (this.state.RepeatInterval && this.state.RepeatInterval > 1) ? `${this.state.RepeatInterval} ${typeLabel}` : typeLabel.replace('s', '');

            let newFormData =
            {
                // ...formData, 
                StartDate: this.state.StartDate,
                endDateForRecurrency: new Date(new moment(newEndDate).startOf('d')),
                MonthValue: MonthValue,
                RepeatValue: RepeatValue,
                RepeatInterval: newIntRepeatInterval,
                EndSelection: EndSelection,
                OccurrencesField: newIntOccurrences,
                selectedWeekDays: selectedWeekDays,
                customMonthlyOptionSelected: customMonthlyOptionSelected,
                customMonthlyDayNumber: customMonthlyDayNumber,
                customSelectedMonthlyOrdinalPosition: customSelectedMonthlyOrdinalPosition,
                customSelectedMonthlyRepetitionDay: customSelectedMonthlyRepetitionDay,
                OccurrenceLabel: this.getOccurrenceLabel(daysLabel, this.state.StartDate, newEndDate),
                initialRecurrenceDate: initialRecurrenceDate
            };

            if (this.state.onCloseModalHandler) {
                this.state.onSaveFormHandler(newFormData);
            }
        } catch (err) {
        }
    }

    EndDateSwitchChangeHandler = () => {
        this.props.dispatch(change('RecurrenceModalForm', 'EnableEndDate_Switch', !this.state.endDateEnabled))
        this.setState((prevState) => ({ endDateEnabled: !prevState.endDateEnabled }))

    }

    render() {
        let modalSize = {}

        switch (this.state.RepeatValue.name) {
            case 'Weekly':
                modalSize = { height: '580px', width: '600px' }
                break;
            case 'Monthly':
            case 'Yearly':
                modalSize = { height: '690px', width: '800px' }
                break;
            default:
                modalSize = { height: '530px', width: '550px' }
                break;
        }

        return (
            <Modal
                open={this.state.openModal}
                onClose={() => this.state.onCloseModalHandler ? this.state.onCloseModalHandler() : ''}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Paper elevation={3} className="paperModal EngageModal" color='secondary' style={modalSize}>
                    <Grid item container style={{ padding: '10px 20px', height: '100%' }}>
                        <Grid item container style={{ height: '10%' }}>
                            <this.TitleComponent />
                        </Grid>
                        <Grid item container style={{ height: '75%' }}>
                            <this.ContentComponent />
                        </Grid>
                        <Grid item container style={{ height: '15%' }}>
                            <this.ButtonsComponent />
                        </Grid>
                    </Grid>
                </Paper>
            </Modal>

        )
    }
}

function mapStateToProps(state) {
    const thiscommunityId = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : undefined
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, timeZoneName: item.timeZoneName })) : [];

    const communityFound = communityData.find(c => c.communityId === thiscommunityId)

    return {
        communityFound
    };
};


export default connect(mapStateToProps, {})(reduxForm({
    form: 'RecurrenceModalForm',
    validate,
    enableReinitialize: true,
})(RecurrenceModal));

